// Mapbox token + upload bucket come from runtime config (config.json), never
// hardcoded here. Re-exported so existing import sites can keep importing from
// "../contants".
import { getMapboxToken, getUploadBucket } from "./config/app-config";
export { getMapboxToken, getUploadBucket };

// constants.ts - REPLACE your existing SPECIAL_PROJECTS with this enhanced version

export const SPECIAL_PROJECTS = {
    '237': {
      id: '237',
      name: 'City of Calgary Project',
      mapboxKey: 'pk.eyJ1Ijoic3VwcG9ydC1sdXgiLCJhIjoiY21haDExd25yMDcwbDJ3b2tuYWIwNDRxYiJ9.lOuK4EA4Q1pqj7cezBFNNg',
      // Point cloud viewer special settings
      tilesets: [
        // Combined Hillshade Layer - All 22 valid tilesets as one layer
        {
          id: 'Spyhill Hillshade',
          name: 'Hillshade',
          mapboxName: 'Spyhill Hillshade',
          type: 'combined-hillshade',
          layerType: 'hillshade',
          comments: 'Hillshade layer',
          isCombinedLayer: true,
          individualTilesets: [
            { id: 'support-lux.spyhill-hillshade', name: 'Spyhill Hillshade' }
          ],
          paint: {
            'hillshade-shadow-color': '#808080',        // Softer medium gray shadows
            'hillshade-highlight-color': '#d0d0d0',     // Softer light gray highlights  
            'hillshade-accent-color': '#a0a0a0',        // Softer medium-light gray accents
            'hillshade-exaggeration': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.3,
              6, 0.4,
              10, 0.5,
              14, 0.6,
              16, 0.7,
              18, 0.8,
              20, 0.9,
              22, 1.0,
              24, 1.1                               // Maximum exaggeration at zoom 24
            ],
            'hillshade-illumination-direction': 315,     // Northwest lighting (softer)
            'hillshade-illumination-anchor': 'map',
            'hillshade-shadow-blur': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.5,
              10, 0.3,
              16, 0.1,
              20, 0.0,
              22, 0.0,
              24, 0.0                               // No blur at maximum zoom for crisp detail
            ]
          },
          demMetadata: {
            verticalUnits: 'meters',
            horizontalDatum: 'WGS84',
            verticalDatum: 'EGM96',
            resolution: '0.5m',
            dataType: 'elevation',
            source: 'Custom high-resolution GeoTIFF DEM',
            region: 'Project Area',
            tilesetCount: 22
          }
        },
      ],
      
      // Enhanced project settings for high-resolution
      projectSettings: {
        defaultTerrainExaggeration: 2.0,     // Higher default for 0.5m data
        defaultHillshadeEnabled: true,
        highResolutionMode: true,
        autoLoadCustomTerrain: true,
        // preferredZoomLevel: 16,               // Start at detailed zoom
        maxDetailZoom: 24                     // Maximum zoom for detail
      }
    },
    '430': {
      id: '430',
      name: 'NRM Project',
      mapboxKey: 'pk.eyJ1IjoibnJtLWx1eCIsImEiOiJjbWN6Y3lvdW8wd3lyMmxwZzRxdGIzcXJhIn0.WvGNDuVeglDMwVkk3APQUA',
      // Point cloud viewer special settings
      tilesets: [
        // Combined Hillshade Layer - All 22 valid tilesets as one layer
        {
          id: 'nrm-lux-combined-hillshade',
          name: 'Hillshade',
          mapboxName: 'Hillshade layer',
          type: 'combined-hillshade',
          layerType: 'hillshade',
          comments: 'Hillshade layer',
          isCombinedLayer: true,
          individualTilesets: [
            { id: 'nrm-lux.clipped_dem_15_hillshade', name: 'DEM Hillshade' }
          ],
          paint: {
            'hillshade-shadow-color': '#808080',        // Softer medium gray shadows
            'hillshade-highlight-color': '#d0d0d0',     // Softer light gray highlights  
            'hillshade-accent-color': '#a0a0a0',        // Softer medium-light gray accents
            'hillshade-exaggeration': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.3,
              6, 0.4,
              10, 0.5,
              14, 0.6,
              16, 0.7,
              18, 0.8,
              20, 0.9,
              22, 1.0
            ],
            'hillshade-illumination-direction': 315,     // Northwest lighting (softer)
            'hillshade-illumination-anchor': 'map',
            'hillshade-shadow-blur': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.5,
              10, 0.3,
              16, 0.1,
              20, 0.0,
              22, 0.0
            ]
          },
          demMetadata: {
            verticalUnits: 'meters',
            horizontalDatum: 'WGS84',
            verticalDatum: 'EGM96',
            resolution: '0.5m',
            dataType: 'elevation',
            source: 'Custom high-resolution GeoTIFF DEM',
            region: 'Project Area',
            tilesetCount: 22
          }
        },
      ],
      
      // Enhanced project settings for high-resolution
      projectSettings: {
        defaultTerrainExaggeration: 2.0,     // Higher default for 0.5m data
        defaultHillshadeEnabled: true,
        highResolutionMode: true,
        autoLoadCustomTerrain: true,
        preferredZoomLevel: 16,               // Start at detailed zoom
        maxDetailZoom: 22                     // Maximum zoom for detail
      }
    },
    '331': {
      id: '331',
      name: 'NRM Project',
      mapboxKey: 'pk.eyJ1IjoibnJtLWx1eCIsImEiOiJjbWN6Y3lvdW8wd3lyMmxwZzRxdGIzcXJhIn0.WvGNDuVeglDMwVkk3APQUA',
      // Point cloud viewer special settings
      tilesets: [
        // Combined Hillshade Layer - All 22 valid tilesets as one layer
        {
          id: 'nrm-lux-combined-hillshade',
          name: 'Hillshade',
          mapboxName: 'Combined Hillshade',
          type: 'combined-hillshade',
          layerType: 'hillshade',
          comments: 'Combined hillshade layer containing 22 individual tilesets',
          isCombinedLayer: true,
          individualTilesets: [
            { id: 'nrm-lux.clipped_dem_1_hillshade', name: 'DEM 1 Hillshade' },
            { id: 'nrm-lux.clipped_dem_2_hillshade', name: 'DEM 2 Hillshade' },
            { id: 'nrm-lux.clipped_dem_3_hillshade', name: 'DEM 3 Hillshade' },
            { id: 'nrm-lux.clipped_dem_4_hillshade', name: 'DEM 4 Hillshade' },
            { id: 'nrm-lux.clipped_dem_5_hillshade', name: 'DEM 5 Hillshade' },
            { id: 'nrm-lux.clipped_dem_6_hillshade', name: 'DEM 6 Hillshade' },
            { id: 'nrm-lux.clipped_dem_7_hillshade', name: 'DEM 7 Hillshade' },
            { id: 'nrm-lux.clipped_dem_8_hillshade', name: 'DEM 8 Hillshade' },
            { id: 'nrm-lux.clipped_dem_9_hillshade', name: 'DEM 9 Hillshade' },
            { id: 'nrm-lux.clipped_dem_10_hillshade', name: 'DEM 10 Hillshade' },
            { id: 'nrm-lux.clipped_dem_11_hillshade', name: 'DEM 11 Hillshade' },
            { id: 'nrm-lux.clipped_dem_12_hillshade', name: 'DEM 12 Hillshade' },
            { id: 'nrm-lux.clipped_dem_13_hillshade', name: 'DEM 13 Hillshade' },
            { id: 'nrm-lux.clipped_dem_14_hillshade', name: 'DEM 14 Hillshade' },
            { id: 'nrm-lux.clipped_dem_15_hillshade', name: 'DEM 15 Hillshade' },
            { id: 'nrm-lux.clipped_dem_16_hillshade', name: 'DEM 16 Hillshade' },
            { id: 'nrm-lux.clipped_dem_17_hillshade', name: 'DEM 17 Hillshade' },
            { id: 'nrm-lux.clipped_dem_18_hillshade', name: 'DEM 18 Hillshade' },
            { id: 'nrm-lux.clipped_dem_19_hillshade', name: 'DEM 19 Hillshade' },
            { id: 'nrm-lux.clipped_dem_20_hillshade', name: 'DEM 20 Hillshade' },
            { id: 'nrm-lux.clipped_dem_21_hillshade', name: 'DEM 21 Hillshade' },
            { id: 'nrm-lux.clipped_dem_22_hillshade', name: 'DEM 22 Hillshade' }
          ],
          paint: {
            'hillshade-shadow-color': '#808080',        // Softer medium gray shadows
            'hillshade-highlight-color': '#d0d0d0',     // Softer light gray highlights  
            'hillshade-accent-color': '#a0a0a0',        // Softer medium-light gray accents
            'hillshade-exaggeration': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.3,
              6, 0.4,
              10, 0.5,
              14, 0.6,
              16, 0.7,
              18, 0.8,
              20, 0.9,
              22, 1.0
            ],
            'hillshade-illumination-direction': 315,     // Northwest lighting (softer)
            'hillshade-illumination-anchor': 'map',
            'hillshade-shadow-blur': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.5,
              10, 0.3,
              16, 0.1,
              20, 0.0,
              22, 0.0
            ]
          },
          demMetadata: {
            verticalUnits: 'meters',
            horizontalDatum: 'WGS84',
            verticalDatum: 'EGM96',
            resolution: '0.5m',
            dataType: 'elevation',
            source: 'Custom high-resolution GeoTIFF DEM',
            region: 'Project Area',
            tilesetCount: 22
          }
        },
        // NEW: Combined DEM Layer for terrain exaggeration
        {
          id: 'nrm-lux-combined-dem',
          name: 'DEM Terrain',
          mapboxName: 'Combined DEM',
          type: 'combined-dem',
          layerType: 'hillshade',
          comments: 'Combined DEM layer containing 22 individual tilesets for terrain exaggeration',
          isCombinedLayer: true,
          individualTilesets: [
            { id: 'nrm-lux.c7j1o9r4', name: 'DEM 1' },
            { id: 'nrm-lux.1c8or6ao', name: 'DEM 2' },
            { id: 'nrm-lux.dq6um36v', name: 'DEM 3' },
            { id: 'nrm-lux.9sab0rii', name: 'DEM 4' },
            { id: 'nrm-lux.b53qg7kx', name: 'DEM 5' },
            { id: 'nrm-lux.axfocbnj', name: 'DEM 6' },
            { id: 'nrm-lux.4g5cnwwr', name: 'DEM 7' },
            { id: 'nrm-lux.7duel1o4', name: 'DEM 8' },
            { id: 'nrm-lux.8g1144l5', name: 'DEM 9' },
            { id: 'nrm-lux.582jqsxt', name: 'DEM 10' },
            { id: 'nrm-lux.198gu6kq', name: 'DEM 11' },
            { id: 'nrm-lux.4l3v1s77', name: 'DEM 12' },
            { id: 'nrm-lux.4r6d9z18', name: 'DEM 13' },
            { id: 'nrm-lux.83nq1o35', name: 'DEM 14' },
            { id: 'nrm-lux.5adz5ipj', name: 'DEM 15' },
            { id: 'nrm-lux.6ty2sdlj', name: 'DEM 16' },
            { id: 'nrm-lux.6e1m6eqf', name: 'DEM 17' },
            { id: 'nrm-lux.21zom03j', name: 'DEM 18' },
            { id: 'nrm-lux.51c0xrtx', name: 'DEM 19' },
            { id: 'nrm-lux.9b0q0r33', name: 'DEM 20' },
            { id: 'nrm-lux.1ghiaqih', name: 'DEM 21' },
            { id: 'nrm-lux.dw6fmu9o', name: 'DEM 22' }
          ],
          paint: {
            'hillshade-shadow-color': '#404040',        // Darker shadows for DEM
            'hillshade-highlight-color': '#e0e0e0',     // Brighter highlights for DEM
            'hillshade-accent-color': '#808080',        // Medium gray accents
            'hillshade-exaggeration': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.5,
              6, 0.6,
              10, 0.7,
              14, 0.8,
              16, 0.9,
              18, 1.0,
              20, 1.2,
              22, 1.5
            ],
            'hillshade-illumination-direction': 315,     // Northwest lighting
            'hillshade-illumination-anchor': 'map',
            'hillshade-shadow-blur': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 0.3,
              10, 0.2,
              16, 0.1,
              20, 0.0,
              22, 0.0
            ]
          },
          demMetadata: {
            verticalUnits: 'meters',
            horizontalDatum: 'WGS84',
            verticalDatum: 'EGM96',
            resolution: '0.5m',
            dataType: 'elevation',
            source: 'Custom high-resolution GeoTIFF DEM',
            region: 'Project Area',
            tilesetCount: 22
          }
        }
      ],
      
      // ENHANCED: Custom terrain sources for 3D terrain
      customTerrainSources: {
        'nrm-dem-1': {
          name: 'DEM 1 (0.5m)',
          type: 'raster-dem',
          url: 'mapbox://nrm-lux.c7j1o9r4',
          tileSize: 512,
          maxzoom: 22,
          stable: true,
          description: 'DEM 1 (0.5m) for 3D terrain exaggeration',
          encoding: 'mapbox'
        },
        'nrm-dem-2': {
          name: 'DEM 2 (0.5m)',
          type: 'raster-dem',
          url: 'mapbox://nrm-lux.1c8or6ao',
          tileSize: 512,
          maxzoom: 22,
          stable: true,
          description: 'DEM 2 (0.5m) for 3D terrain exaggeration',
          encoding: 'mapbox'
        },
        'nrm-dem-3': {
          name: 'DEM 3 (0.5m)',
          type: 'raster-dem',
          url: 'mapbox://nrm-lux.dq6um36v',
          tileSize: 512,
          maxzoom: 22,
          stable: true,
          description: 'DEM 3 (0.5m) for 3D terrain exaggeration',
          encoding: 'mapbox'
        },
        'nrm-dem-hillshade': {
          name: 'DEM Hillshade (0.5m)',
          type: 'raster-dem',
          url: 'mapbox://nrm-lux.clipped_dem_1_hillshade',
          tileSize: 512,
          maxzoom: 22,
          stable: true,
          description: 'DEM Hillshade (0.5m) for 3D terrain exaggeration',
          encoding: 'mapbox'
        }

      },
      
      // Enhanced project settings for high-resolution
      projectSettings: {
        defaultTerrainExaggeration: 2.0,     // Higher default for 0.5m data
        defaultHillshadeEnabled: true,
        highResolutionMode: true,
        autoLoadCustomTerrain: true,
        // preferredZoomLevel: 16,               // Start at detailed zoom
        maxDetailZoom: 22                     // Maximum zoom for detail
      }
    }
  };
  
  // ADD THIS HELPER FUNCTION TO YOUR constants.ts:
  // Updated to show continental view of Canada/USA instead of NRM project extent
  // This provides a better initial view for customers from both Canada and USA
  export function getProjectCenter() {
    return {
      lng: -100.0,    // Center of North America (Canada/USA)
      lat: 50.0,      // Center of North America (Canada/USA)
      zoom: 3         // Continental view showing Canada and USA
    };
  }

  
  // NEW: Helper function to get custom terrain sources
  export function getCustomTerrainSources(projectId: string) {
    const project = SPECIAL_PROJECTS[projectId];
    return project?.customTerrainSources || {};
  }
  
  export function hasCustomTerrain(projectId: string): boolean {
    const project = SPECIAL_PROJECTS[projectId];
    return !!(project?.customTerrainSources && Object.keys(project.customTerrainSources).length > 0);
  }
  

export const NRM_PROJECT_TILESETS = SPECIAL_PROJECTS['331']?.tilesets || [];

export const MAPSTYLES = [
    ["Satellite Streets", "mapbox://styles/mapbox/satellite-streets-v11"],
    ["Topographic", "mapbox://styles/mapbox/outdoors-v11"],
    ["Streets", "mapbox://styles/mapbox/streets-v11"],
    ["Satellite", "mapbox://styles/mapbox/satellite-v9"],
    ["Standard", "mapbox://styles/mapbox/standard"],
    ["Dark", "mapbox://styles/mapbox/dark-v10"],
    ["Topographic Dark", "mapbox://styles/mapbox/navigation-night-v1"],
    ["Streets Dark", "mapbox://styles/mapbox/dark-v10"],
    // ["Monochrome Dark", "mapbox://styles/mapbox/dark-v10"],
];

export const PDAL_PIPELINES = [
    {
        name: 'SO Filter', pipeline: {
            "pipeline": [
                {
                    "type": "filters.outlier",
                    "method": "statistical",
                    "mean_k": 12,
                    "multiplier": 2.2
                },
                {
                    "type": "filters.range",
                    "limits": "Classification![7:7]"
                },
            ]
        }, comments: ''
    },
    {
        name: 'SO Filter and Decimate', pipeline: {
            "pipeline": [
                {
                    "type": "filters.outlier",
                    "method": "statistical",
                    "mean_k": 12,
                    "multiplier": 2.2
                },
                {
                    "type": "filters.range",
                    "limits": "Classification![7:7]"
                },
                {
                    "type": "filters.decimation",
                    "step": 2
                }
            ]
        }, comments: ''
    },
    {
        name: 'Ground Classification', pipeline: {
            "pipeline": [
                {
                    "type": "filters.elm"
                },
                {
                    "type": "filters.outlier"
                },
                {
                    "type": "filters.smrf",
                    "ignore": "Classification[7:7]",
                    "slope": 0.2,
                    "window": 16,
                    "threshold": 0.45,
                    "scalar": 1.2
                },
                {
                    "type": "filters.range",
                    "limits": "Classification[2:2]"
                }
            ]
        }, comments: ''
    },
];

export const EXAMPLE_LAYERS = [
    {
        name: 'Ditchline', value:
            [{
                "type": "line",
                "paint": {
                    "line-color": "black",
                    "line-width": 3
                }
            }
            ]
    },
    {
        name: 'KPs', value:
            [
                {
                    "type": "circle",
                    "minzoom": 10,
                    "paint": {
                        "circle-radius": {
                            "base": 1.75,
                            "stops": [
                                [
                                    12,
                                    2
                                ],
                                [
                                    22,
                                    50
                                ]
                            ]
                        },
                        "circle-color": "#FFF"
                    }
                },
                {
                    "type": "symbol",
                    "minzoom": 10,
                    "paint": {
                        "text-color": "white"
                    },
                    "layout": {
                        "text-field": "{Name}",
                        "text-font": [
                            "Open Sans Semibold",
                            "Arial Unicode MS Bold"
                        ],
                        "text-offset": [
                            3,
                            -0.75
                        ],
                        "text-anchor": "right"
                    }
                }
            ]
    },
    {
        name: 'ROW', value:
            [
                {
                    "type": "fill",
                    "layout": {},
                    "paint": {
                        "fill-color": "#FFDB58",
                        "fill-opacity": 0.2
                    }
                },
                {
                    "type": "line",
                    "layout": {},
                    "paint": {
                        "line-color": "#FFDB58",
                        "line-width": 1
                    }
                }
            ]
    },
    {
        name: 'TWS', value:
            [
                {
                    "type": "fill",
                    "layout": {},
                    "paint": {
                        "fill-color": "pink",
                        "fill-opacity": 0.4
                    }
                },
                {
                    "type": "line",
                    "layout": {},
                    "paint": {
                        "line-color": "grey",
                        "line-width": 1
                    }
                }
            ]
    },
];

export const POINTCLOUD_VIEW_SPECIAL = {
  '430': {
    pointCloudDefaults: {
      attribute: 'elevation',
      attributeName: 'elevation (gradient)',
      gradient: 'YELLOW_GREEN'
    }
  },
  '331': {
    pointCloudDefaults: {
      attribute: 'elevation',
      attributeName: 'elevation (gradient)',
      gradient: 'YELLOW_GREEN'
    }
  },
  '364': {
    pointCloudDefaults: {
      attribute: 'elevation',
      attributeName: 'elevation (gradient)',
      gradient: 'YELLOW_GREEN'
    }
  }
};

// Generic helpers to eliminate hard-coding in components

export function getProjectConfig(projectId: string) {
  return SPECIAL_PROJECTS[String(projectId)] || null;
}

export function getProjectTilesets(projectId: string) {
  const project = getProjectConfig(projectId);
  return project?.tilesets || [];
}

export function getTilesetsByType(projectId: string, layerType: string) {
  return getProjectTilesets(projectId).filter((t: any) => t.layerType === layerType);
}

export function getCombinedLayerId(projectId: string, layerType: string) {
  const tileset = getProjectTilesets(projectId).find(
    (t: any) => t.isCombinedLayer === true && t.layerType === layerType
  );
  return tileset ? tileset.id : null;
}

export function getFirstTilesetId(projectId: string, layerType: string) {
  const combined = getProjectTilesets(projectId).find(
    (t: any) => t.isCombinedLayer === true && t.layerType === layerType
  );
  if (combined && Array.isArray(combined.individualTilesets) && combined.individualTilesets.length > 0) {
    return combined.individualTilesets[0].id;
  }
  const single = getProjectTilesets(projectId).find(
    (t: any) => t.layerType === layerType && !t.isCombinedLayer
  );
  return single ? single.id : null;
}

export function getTilesetPaint(projectId: string, layerId: string) {
  const tileset = getProjectTilesets(projectId).find((t: any) => t.id === layerId);
  return tileset?.paint || {};
}

export function getDefaultProjectSettings(projectId: string) {
  const project = getProjectConfig(projectId);
  return project?.projectSettings || {};
}

export function getCombinedHillshadeTileset(projectId: string) {
  return getProjectTilesets(projectId).find(
    (t: any) => t.isCombinedLayer === true && t.layerType === 'hillshade'
  );
}

export function getCombinedDEMTileset(projectId: string) {
  return getProjectTilesets(projectId).find(
    (t: any) => t.isCombinedLayer === true && t.layerType === 'hillshade' && t.type === 'combined-dem'
  );
}

export function getAllIndividualTilesetIds(projectId: string) {
  const tilesets = getProjectTilesets(projectId);
  const ids: string[] = [];
  
  tilesets.forEach((t: any) => {
    if (t.isCombinedLayer && Array.isArray(t.individualTilesets)) {
      t.individualTilesets.forEach((it: any) => ids.push(it.id));
    } else if (t.id) {
      ids.push(t.id);
    }
  });
  
  return ids;
}

export function isSpecialProject(projectId: string): boolean {
  return !!SPECIAL_PROJECTS[String(projectId)];
}

export function getProjectMapboxToken(projectId: string): string {
  const project = getProjectConfig(projectId);
  return project?.mapboxKey || getMapboxToken();
}